export const tableRules = {
  type: [{ required: true, message: '维修类型必填' }],
  location: [
    { required: true, message: '维修地点必填' },
    { min: 2, max: 30, message: '长度在 2 到 30 个字符' },
  ],
  content: [
    { required: true, message: '维修内容必填' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符' },
  ],
  estimatedCost: [
    {
      pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
      message: '请输入正确的格式,可保留两位小数',
    },
  ],
  plan: [{ min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' }],
  remark: [{ min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' }],
};

export const formRules = () => {
  return {
    workOrderCompanyNo: [{ required: true, message: '公司必填', trigger: 'blur' }],
    name: [
      { required: true, message: '工单名称必填' },
      { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
    ],
    receivePersonName: [
      { required: true, message: '接单人必填', trigger: 'blur' },
      { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' },
    ],
    dispatchPersonName: [{ required: true, message: '派单人必填', trigger: 'blur' }],
    workOrderDepartmentNo: [{ required: true, message: '派单部门必填', trigger: 'blur' }],
    type: [{ required: true, message: '工单类型必填' }],
    contactPhone: [{ pattern: /^(?!0)\d{0,20}$/, message: '请输入正确的格式,0到20位整数' }],
    remark: [{ min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' }],
  };
};
